var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9219 19.6146C17.6056 19.6146 17.3023 19.7403 17.0786 19.964C16.8549 20.1876 16.7293 20.491 16.7293 20.8073V25.5781H19.1146V22H22.6927V24.9817L26.8671 20.8073L22.6927 16.6329V19.6146H17.9219ZM22.3432 9.3492L34.1508 21.1568C34.3744 21.3804 34.5 21.6837 34.5 22C34.5 22.3163 34.3744 22.6196 34.1508 22.8432L22.3432 34.6508C22.1196 34.8744 21.8163 35 21.5 35C21.1837 35 20.8804 34.8744 20.6568 34.6508L8.8492 22.8432C8.62561 22.6196 8.5 22.3163 8.5 22C8.5 21.6837 8.62561 21.3804 8.8492 21.1568L20.6568 9.3492C20.8804 9.12561 21.1837 9 21.5 9C21.8163 9 22.1196 9.12561 22.3432 9.3492Z",
    fill: "#FA9418"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionIcon);
export default __webpack_public_path__ + "static/media/direction-icon.bf431e33082b562388ad47ee6728b943.svg";
export { ForwardRef as ReactComponent };